module.exports = [
  require('./mind_sliver'),
]
